import cookies from 'js-cookie';
import { easel, images, tokenProvider } from '@marvelapp/easel-client';
export default function configureEasel(_a) {
    var canvasEaselHost = _a.canvasEaselHost;
    // These URIs are blank because it will then use the URI that the environment is on.
    // Mostly useful for local development, where an explicit value would break the proxy
    tokenProvider.baseUri = '';
    images.baseUri = '';
    easel.baseUri = canvasEaselHost;
    easel.versionPathString = 'v2';
    images.csrfToken = cookies.get('csrftoken');
}
